import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdOutlineEdit } from "react-icons/md";
import { Container } from "reactstrap";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";
import toast from "react-hot-toast";
import {
  getServices,
  updateServices,
} from "../../../../apiServices/apiServices";
import ManageCmsDialog from "../Modal/Cms/ManageCmsDialog";

function ManageCMSView() {
  const [aboutData, setAboutData] = useState("");
  const [about, setAbout] = useState("");
  const [loading, setLoading] = useState({ page: false });
  const [dialog, setDialog] = useState(false);
  const access_token = sessionStorage.getItem("access-token");

  useEffect(() => {
    fetchAboutusData();
  }, []);

  const fetchAboutusData = async () => {
    setLoading({ ...loading, page: true });

    try {
      const res = await getServices(`/api/cms/about`, access_token);

      setLoading({ ...loading, page: false });
      if (res.responseCode === 200) {
        setAbout(res.responseData?.about ?? "");
      } else {
        setAbout("");
        toast.error(res.responseMessage || "Something went worng");
      }
    } catch (error) {
      setLoading({ ...loading, page: false });
      toast.error(error || "Something went wrong");
    }
  };

  const handleAboutUpdateModal = () => {
    setDialog(true);
    setAboutData(about);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await updateServices(`/api/cms/about`, access_token, {
        about: aboutData,
      });

      if (res.responseCode === 200) {
        setDialog(false);
        fetchAboutusData();
      } else {
        toast.error(res.responseMessage || "Something went wrong");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    }
  };

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <Container className="flex justify-between items-center mx-0 px-4 pt-4 sm:px-8 sm:pt-8">
            <p className="text-xl sm:text-2xl font-semibold">Manage CMS</p>
          </Container>

          {!loading.page ? (
            <Container className="px-4 md:px-8 mt-3">
              <TabContext value="0">
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    // onChange={handleChange}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    sx={{
                      "& .MuiTab-root": {
                        fontFamily: "Poppins",
                      },
                      "& .MuiTab-root.Mui-selected": {
                        color: "#000",
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#000",
                      },
                    }}
                  >
                    <Tab label="About us page" value="0" />
                  </TabList>
                </Box>

                <TabPanel value="0" sx={{ padding: "24px 0" }}>
                  <Container className="flex justify-end">
                    <MdOutlineEdit
                      className="p-2 h-9 w-9 rounded-full cursor-pointer"
                      style={{ backgroundColor: "#ffe1a1" }}
                      onClick={() => handleAboutUpdateModal()}
                    />
                  </Container>

                  {about ? (
                    <Container className="mt-2">
                      <div
                        className="prose prose-gray max-w-none"
                        dangerouslySetInnerHTML={{
                          __html: about,
                        }}
                      />
                    </Container>
                  ) : (
                    <Container className="text-center mx-8 mt-5 sm:mt-5">
                      <p className="font-semibold">No data found!!!</p>
                    </Container>
                  )}
                </TabPanel>
              </TabContext>
            </Container>
          ) : (
            <Container className="min-h-[35vh] flex justify-center items-center">
              <p className="text-center font-semibold">Loading...</p>
            </Container>
          )}
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}

      <ManageCmsDialog
        open={dialog}
        onClose={() => setDialog(false)}
        handleSubmit={handleSubmit}
        setAboutData={setAboutData}
        aboutData={aboutData}
      />
    </>
  );
}

export default ManageCMSView;
